﻿import { setCookie, getCookie } from '../functions';

const COOKIENAME = 'occ';

document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.dataLayer === 'undefined') window.dataLayer = [];

    (document.querySelectorAll('.cookie .cookie-accept') || []).forEach(($delete) => {
        const $notification = $delete.parentNode.parentNode;

        let cookieConsent = getCookie(COOKIENAME);

        if (cookieConsent) {
            $notification.parentNode.removeChild($notification);
        }
        else {
            $delete.addEventListener('click', () => {
                $notification.parentNode.removeChild($notification);
                setCookie(COOKIENAME, true, 365);
            });
        }
    });
});